// extracted by mini-css-extract-plugin
export default {"container":"J35lYl","border":"GztbUt","grid":"lT_atc","mobile":"RlQYhm"};